import { render, staticRenderFns } from "./NeZaman.vue?vue&type=template&id=651f2d81&"
import script from "./NeZaman.vue?vue&type=script&lang=js&"
export * from "./NeZaman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports